import React from 'react';
import { View } from 'react-native';
import QuestionButton from '../Buttons/QuestionButton';
import RegularText from '../Text/RegularText';

//= ========================================================================
const QuestionPopup = ({
  onYesPressed,
  onNoPressed,
  question,
  leftButtonText,
  rightButtonText,
  smallButton,
}) => (
  <View style={{
    padding: 32,
    width: 464,
    minHeight: 242,
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 2,
    backgroundColor: '#fff',
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.22,
    shadowRadius: 12,
    textAlign: 'left',
  }}
  >
    <RegularText>{question}</RegularText>
    <View style={{ flexDirection: 'row', marginTop: 'auto' }}>
      <QuestionButton isHallow onPress={onNoPressed} leftButtonText={leftButtonText} smallButton={smallButton} />
      <QuestionButton onPress={onYesPressed} rightButtonText={rightButtonText} />
    </View>
  </View>
);

export default QuestionPopup;
